import type { TimePeriodId } from '@myfunnow/web-core/time-filter'

export const TIME_PERIOD_I18N_MAP: Record<TimePeriodId, { labelI18n: string; rangeTextI18n: string }> = {
  morning: { labelI18n: 'time_morning', rangeTextI18n: 'filter_morning_time' },
  noon: { labelI18n: 'time_noon', rangeTextI18n: 'filter_noon_time' },
  afternoon: { labelI18n: 'time_afternoon', rangeTextI18n: 'filter_afternoon_time' },
  night: { labelI18n: 'time_night', rangeTextI18n: 'filter_night_time' },
  midnight: { labelI18n: 'time_midnight', rangeTextI18n: 'filter_early_morning_time' },
}

export enum FilterTypes {
  SORTBY = 'sortby',
  NOW = 'now',
  FILTER_KEYWORD = 'filter_keyword',
  FILTER_TIME = 'filter_time',
  START_TIME = 'starttime',
  END_TIME = 'endtime',
  MIN_PRICE = 'min_price',
  MAX_PRICE = 'max_price',
  MIN_BRANCH_RATING = 'min_branch_rating',
  FILTER_TAGS = 'filter_tags',
  SOURCE_CATEGORY_ID = 'source_category_id',
  LIMIT = 'limit',
  FILTER_TIMES = 'filter_times',
}

export enum FilterOptionKey {
  // TODO: reuse "NOW" with filter-setting.js
  NOW = 'now',
  DATE = 'date',
  HEAD_COUNT = 'headcount',
  PRICE = 'price',
  RATING = 'rating',
  TIME = 'time',
}

export enum CategorySortKey {
  POPULAR = 'popular',
  POPULAR_OVER_DISTANCE = 'popular_over_distance',
  DISTANCE = 'distance',
  PRICE_HIGH = 'price_high',
  PRICE_LOW = 'price_low',
}

export enum FilterFromPage {
  SEARCH = 'SearchPage',
  TAG = 'TagPage',
}
